var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search" },
    [
      _c(
        "label",
        { staticClass: "label-search", attrs: { for: "search-distribuidor" } },
        [_vm._v(_vm._s(_vm.label_text))]
      ),
      _vm._v(" "),
      _c("b-form-input", {
        staticClass: "radius-theme",
        attrs: {
          id: "search-distribuidor",
          placeholder: "Digite aqui código do distribuidor",
          autocomplete: "off",
          disabled: _vm.disabled,
          type: "number"
        },
        on: {
          keyup: _vm.fetchdistribuidores,
          blur: function($event) {
            _vm.visibleResult = false
          },
          focus: function($event) {
            _vm.visibleResult = true
          }
        },
        model: {
          value: _vm.search,
          callback: function($$v) {
            _vm.search = $$v
          },
          expression: "search"
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visibleResult,
                expression: "visibleResult"
              }
            ],
            staticClass: "search-result default-card"
          },
          [
            _c(
              "div",
              { staticClass: "result-list" },
              _vm._l(_vm.distribuidores, function(distribuidor) {
                return _c(
                  "b-row",
                  {
                    key: distribuidor.id,
                    on: {
                      click: function($event) {
                        return _vm.selecteddistribuidor(distribuidor)
                      }
                    }
                  },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "bressay-bold-italic distribuidor-name",
                        attrs: { md: "8" }
                      },
                      [
                        _vm._v(
                          "\n                        (" +
                            _vm._s(distribuidor.codigo) +
                            ") " +
                            _vm._s(_vm.capitalize(distribuidor.nome)) +
                            "\n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _vm.searching
              ? _c("b-spinner", { attrs: { medium: "" } })
              : _vm.distribuidores.length == 0
              ? _c("p", { staticClass: "text-center" }, [
                  _vm._v("Nenhum distribuidor encontrado")
                ])
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d9c7816", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d9c7816","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/BuscaDistribuidor.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0d9c7816","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/BuscaDistribuidor.vue
// module chunks = 2